export default __webpack_public_path__ + "static/media/SignUp.63183313.png";